export default __webpack_public_path__ + "static/media/Mystic's Shoes of the Aureate.74037d0c.jpg";